import IntroStoreSearch from './IntroStoreSearch';

export default IntroStoreSearch;
